import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

export default function LegalShell({ eyebrow, title, lastUpdated, children }) {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-14">
      <Link
        to="/"
        className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.18em] text-muted-foreground hover:text-foreground"
        data-testid="legal-back-link"
      >
        <ChevronLeft className="h-3.5 w-3.5" /> Back to home
      </Link>
      {eyebrow && (
        <span className="mt-6 block text-[11px] uppercase tracking-[0.22em] text-rose-gold">
          {eyebrow}
        </span>
      )}
      <h1 className="mt-1 font-display text-4xl sm:text-5xl font-semibold text-ink leading-[1.05]">
        {title}
      </h1>
      {lastUpdated && (
        <p className="mt-3 text-xs text-muted-foreground">Last updated: {lastUpdated}</p>
      )}
      <div className="mt-8 prose-article">{children}</div>
    </div>
  );
}
